'use client';

import { createContext, useCallback, useContext, useState } from 'react';
import { OverlayToaster, type Toaster } from '@blueprintjs/core';

const ToasterContext = createContext<Toaster | null>(null);

export default function ToasterProvider({ children }) {
    const [toaster, setToaster] = useState<Toaster | null>(null);

    const handleToasterRef = useCallback(
        (instance: OverlayToaster | null) => setToaster(instance),
        [],
    );

    return (
        <>
            <OverlayToaster ref={handleToasterRef} />
            <ToasterContext.Provider value={toaster}>
                {children}
            </ToasterContext.Provider>
        </>
    );
}

export function useToaster() {
    return useContext(ToasterContext);
}
